import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { GET_SCHEDULERS_QUERY_KEY } from './useGetScheduledReports.query';
interface Params {
  id: string;
}
const useDeactivateScheduledReportQuery = ({ id }: Params) => {
  const queryClient = useQueryClient();
  const { isLoading, mutateAsync } = useMutation(
    () => api.patch(API_URL.REPORTS_SCHEDULERS_DEACTIVATE_BY_ID(id)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_SCHEDULERS_QUERY_KEY],
        });
      },
    }
  );
  return {
    isLoading,
    handleSubmit: mutateAsync,
  };
};

export default useDeactivateScheduledReportQuery;
